import React from "react";

import { css, cx } from "@emotion/css";

import { Icons } from "@/assets/icons.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { Button } from "@/uiKit/atoms/Button.tsx";
import { useChatDrawer } from "@/uiKit/atoms/page/PageDrawerState.ts";
import { SuspenseHidden } from "@/uiKit/atoms/SuspenseHidden.tsx";
import { UnreadMessagesDot } from "@/uiKit/organisms/ChatMessaging/UnreadMessagesDot.tsx";
import { PATIENT_NAVIGATION_HEIGHT } from "@/uiKit/organisms/PatientNavigationHeader.tsx";

export type OpenMessagesFloatingButtonProps = {
  className?: string;
};

export const OpenMessagesFloatingButton: React.FC<OpenMessagesFloatingButtonProps> = ({ className }) => {
  const styles = useStyles(makeStyles);
  const drawer = useChatDrawer();

  if (drawer.isOpen || !drawer.isEnabled) {
    return null;
  }

  return (
    <Button
      data-action="messaging.panel.open"
      variant="text"
      className={cx(styles.open, className)}
      onClick={drawer.open}
    >
      <Icons.letter className={styles.openIcon} />
      <SuspenseHidden>
        <UnreadMessagesDot className={styles.dot} />
      </SuspenseHidden>
    </Button>
  );
};

const makeStyles = (theme: Theme) => ({
  open: css({
    position: "sticky",
    top: PATIENT_NAVIGATION_HEIGHT,
    right: 0,
    padding: theme.spacing(2, 4),
    margin: theme.spacing(4, 0),
    backgroundColor: theme.palette.background.paper,
    height: "fit-content",
    minWidth: 0,
    ".MuiButton-label": {
      padding: 0,
      margin: 0,
    },
  }),
  dot: css({
    position: "absolute",
    top: theme.spacing(1),
    right: theme.spacing(2),
  }),
  openIcon: css({
    width: 26,
    height: 26,
    color: theme.palette.text.primary,
  }),
});
